import { addDays, diffDays, makeDateKey, monthStart, parseDateKey, startOfWeek, type DateKey } from "../dates";

export interface Period {
  from: DateKey;
  to: DateKey;
}

export function thisWeek(today: DateKey): Period {
  return { from: startOfWeek(today), to: today };
}

export function thisMonth(today: DateKey): Period {
  return { from: monthStart(today), to: today };
}

export function thisYear(today: DateKey): Period {
  return { from: makeDateKey(parseDateKey(today).year, 1, 1), to: today };
}

export function lastDays(today: DateKey, days: number): Period {
  return { from: addDays(today, -(days - 1)), to: today };
}

export function periodLength(period: Period): number {
  return diffDays(period.from, period.to) + 1;
}
